var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", [
      _vm._v(_vm._s(_vm.resource("IOFormat_Csv_Upload_Header")) + " *")
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("file-upload", {
          attrs: { accept: ".csv" },
          model: {
            value: _vm.newFile,
            callback: function($$v) {
              _vm.newFile = $$v
            },
            expression: "newFile"
          }
        }),
        _vm._v(" "),
        _vm.showFileError
          ? _c("required-error", { attrs: { fieldName: "CSV File" } })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("label", [
      _vm._v(_vm._s(_vm.resource("IOFormat_Csv_Separator")) + " *")
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newSeparator,
              expression: "newSeparator"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", maxlength: "1" },
          domProps: { value: _vm.newSeparator },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.newSeparator = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _vm.showSeparatorError
          ? _c("required-error", { attrs: { fieldName: "Separator" } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }